module.exports = __webpack_public_path__ + "assets/img/04-699436dc.jpg";